import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

/**
 * Number of feedback submissions in the "new" status (i.e. not yet triaged).
 * Used to badge the Feedbacks sidebar nav item.
 *
 * Mirrors useUnreadInboxCount: simple Supabase count + Realtime subscription
 * so the badge updates the instant a new feedback row is inserted or its
 * status changes away from "new".
 */
export function useNewFeedbackCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const { count: c, error } = await supabase
          .from("feedback")
          .select("id", { count: "exact", head: true })
          .eq("status", "new");
        if (cancelled) return;
        if (error) {
          console.warn("[useNewFeedbackCount] load error:", error.message);
          setCount(0);
        } else {
          setCount(c || 0);
        }
      } catch {
        if (!cancelled) setCount(0);
      }
    }

    load();

    const channel = supabase
      .channel("sidebar-feedback-new")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "feedback" },
        () => load(),
      )
      .subscribe();

    return () => {
      cancelled = true;
      supabase.removeChannel(channel);
    };
  }, []);

  return count;
}
